import React, { useEffect, useState } from 'react'
import { Modal, ModalBody, Input, FormGroup, ModalFooter } from 'reactstrap'
import { useAddEditSessionMutation } from './processApiSlice'
import { useSnackbar } from 'notistack'
import { setSessionProcess } from 'features/public-views/login/loginSlice'
import { useDispatch, useSelector } from 'react-redux'
import PMBProjectSelections from 'components/PMBProjectSelections'
import CustomButton from 'components/Buttons/CustomButton'

const ModalChangeEndOfDay = ({
  isOpen,
  toggle,
  isEndOfDay: initialValue,
  project,
}) => {
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()

  const [autoClose, setAutoClose] = useState(initialValue ?? false)
  const [selectedProject, setSelectedProject] = useState(project || {})

  const [addOrEditSession] = useAddEditSessionMutation()

  useEffect(() => {
    if (isOpen) {
      setAutoClose(initialValue)
      setSelectedProject(project || null)
    }
  }, [isOpen, initialValue, project])

  const onToggleAutoClose = () => {
    setAutoClose(!autoClose)
  }

  const onConfirm = async () => {
    try {
      const res = await addOrEditSession({
        isAutoCloseOnEOD: autoClose ? 1 : 0,
        projectId: selectedProject?.value || selectedProject?.id,
      })

      if (res?.error) throw res

      dispatch(setSessionProcess({ ...res?.data, project: selectedProject }))
      enqueueSnackbar('Pengaturan sesi berhasil diperbarui.', {
        variant: 'success',
      })
      toggle()
    } catch (error) {
      enqueueSnackbar(
        error?.message ?? error?.error?.data?.message ?? 'Terjadi kesalahan.',
        {
          variant: 'error',
        },
      )
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered data-testid="process-settings-modal">
      <ModalBody className="pb-3">
        <h5 className="fw-semibold mb-3">Pengaturan Sesi</h5>

        <div className="d-flex justify-content-between align-items-center mb-1">
          <span className="fw-medium">Tutup otomatis di akhir hari</span>

          <FormGroup switch>
            <Input
              role="switch"
              type="switch"
              checked={autoClose}
              onChange={onToggleAutoClose}
              data-testid="process-settings-autoclose-switch"
            />
          </FormGroup>
        </div>

        <small className="text-muted">
          Sesi akan berakhir otomatis pada tengah malam.
        </small>

        <FormGroup className="mt-3">
          <span className="fw-medium">Project (Opsional)</span>

          <PMBProjectSelections
            className="border-input button w-100"
            placeholder="Pilih project"
            value={selectedProject}
            onChange={setSelectedProject}
            testId="process-settings-project"
          />
        </FormGroup>
      </ModalBody>

      <ModalFooter className="border-0">
        <CustomButton
          className="btn-cancel"
          color="secondary"
          onClick={toggle}
          testId="process-settings-cancel-button"
        >
          Batal
        </CustomButton>
        <CustomButton color="primary" onClick={onConfirm} testId="process-settings-submit-button">
          Simpan
        </CustomButton>
      </ModalFooter>
    </Modal>
  )
}

export default ModalChangeEndOfDay
